import PyrexxOverview from './PyrexxOverview'

export default PyrexxOverview
